import { createBrowserRouter, Navigate } from 'react-router-dom';
import { DocumentTitleProvider, GuestRoute, ModuleAccessRoute, ProtectedRoute, RootRedirect } from '@/routes/guards';
import { ROUTES } from '@/constants/routes';
import { AuthLayout } from '@/layouts/AuthLayout/AuthLayout';
import { MainLayout } from '@/layouts/MainLayout/MainLayout';
import Login from '@/pages/auth/Login';
import ForgotPassword from '@/pages/auth/ForgotPassword';
import VerifyOtp from '@/pages/auth/VerifyOtp';
import ResetPassword from '@/pages/auth/ResetPassword';
import Dashboard from '@/pages/dashboard/Dashboard';
import Profile from '@/pages/account/Profile';
import Categories from '@/pages/categories/Categories';
import Subcategories from '@/pages/subcategories/Subcategories';
import Brands from '@/pages/brands/Brands';
import Assemblies from '@/pages/locations/Assemblies';
import Constituencies from '@/pages/locations/Constituencies';
import Districts from '@/pages/locations/Districts';
import States from '@/pages/locations/States';
import Attributes from '@/pages/attributes/Attributes';
import AttributeValues from '@/pages/attribute-values/AttributeValues';
import Banners from '@/pages/banners/Banners';
import Collections from '@/pages/collections/Collections';
import Media from '@/pages/media/Media';
import Products from '@/pages/products/Products';
import ProductForm from '@/pages/products/ProductForm';
import ProductView from '@/pages/products/ProductView';
import Inventory from '@/pages/inventory/Inventory';
import Reviews from '@/pages/reviews/Reviews';
import Coupons from '@/pages/coupons/Coupons';
import CouponForm from '@/pages/coupons/CouponForm';
import Reports from '@/pages/reports/Reports';
import Customers from '@/pages/customers/Customers';
import CustomerForm from '@/pages/customers/CustomerForm';
import CustomerDetail from '@/pages/customers/CustomerDetail';
import Settings from '@/pages/settings/Settings';
import Users from '@/pages/users/Users';
import UserForm from '@/pages/users/UserForm';
import Cms from '@/pages/cms/Cms';
import SeoSettings from '@/pages/seo/SeoSettings';
import EmailTemplates from '@/pages/email-templates/EmailTemplates';
import Blogs from '@/pages/blogs/Blogs';
import BlogForm from '@/pages/blogs/BlogForm';
import BlogPreview from '@/pages/blogs/BlogPreview';
import Notifications from '@/pages/notifications/Notifications';
import Enquiries from '@/pages/enquiries/Enquiries';
import Contacts from '@/pages/contacts/Contacts';
import Orders from '@/pages/orders/Orders';
import OrderDetail from '@/pages/orders/OrderDetail';

export const router = createBrowserRouter([
  {
    element: <DocumentTitleProvider />,
    children: [
      {
        element: <GuestRoute />,
        children: [
          {
            element: <AuthLayout />,
            children: [
              { path: ROUTES.LOGIN, element: <Login /> },
              { path: ROUTES.FORGOT_PASSWORD, element: <ForgotPassword /> },
              { path: ROUTES.VERIFY_OTP, element: <VerifyOtp /> },
              { path: ROUTES.RESET_PASSWORD, element: <ResetPassword /> },
            ],
          },
        ],
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <ModuleAccessRoute />,
            children: [
              {
                element: <MainLayout />,
                children: [
                  { path: ROUTES.DASHBOARD, element: <Dashboard /> },
                  { path: ROUTES.ORDERS, element: <Orders /> },
                  { path: '/orders/:id', element: <OrderDetail /> },
                  { path: ROUTES.PROFILE, element: <Profile /> },
                  { path: ROUTES.CATEGORIES, element: <Categories /> },
                  { path: ROUTES.SUBCATEGORIES, element: <Subcategories /> },
                  { path: ROUTES.BRANDS, element: <Brands /> },
                  { path: ROUTES.STATES, element: <States /> },
                  { path: ROUTES.DISTRICTS, element: <Districts /> },
                  { path: ROUTES.ASSEMBLIES, element: <Assemblies /> },
                  { path: ROUTES.CONSTITUENCIES, element: <Constituencies /> },
                  { path: ROUTES.ATTRIBUTES, element: <Attributes /> },
                  { path: ROUTES.ATTRIBUTE_VALUES, element: <AttributeValues /> },
                  { path: ROUTES.PRODUCTS, element: <Products /> },
                  { path: ROUTES.PRODUCT_CREATE, element: <ProductForm /> },
                  { path: '/products/:id/edit', element: <ProductForm /> },
                  { path: '/products/:id/view', element: <ProductView /> },
                  { path: ROUTES.BANNERS, element: <Banners /> },
                  { path: ROUTES.COLLECTIONS, element: <Collections /> },
                  { path: ROUTES.MEDIA, element: <Media /> },
                  { path: ROUTES.CMS, element: <Cms /> },
                  { path: ROUTES.SEO, element: <SeoSettings /> },
                  { path: ROUTES.EMAIL_TEMPLATES, element: <EmailTemplates /> },
                  { path: ROUTES.BLOGS, element: <Blogs /> },
                  { path: ROUTES.BLOG_CREATE, element: <BlogForm /> },
                  { path: '/blogs/:id/edit', element: <BlogForm /> },
                  { path: '/blogs/:id/preview', element: <BlogPreview /> },
                  { path: ROUTES.INVENTORY, element: <Inventory /> },
                  { path: ROUTES.REVIEWS, element: <Reviews /> },
                  { path: ROUTES.COUPONS, element: <Coupons /> },
                  { path: ROUTES.COUPON_CREATE, element: <CouponForm /> },
                  { path: '/coupons/:id/edit', element: <CouponForm /> },
                  { path: ROUTES.REPORTS, element: <Reports /> },
                  { path: ROUTES.CUSTOMERS, element: <Customers /> },
                  { path: ROUTES.ENQUIRIES, element: <Enquiries /> },
                  { path: ROUTES.CONTACTS, element: <Contacts /> },
                  { path: ROUTES.NOTIFICATIONS, element: <Notifications /> },
                  { path: ROUTES.CUSTOMER_CREATE, element: <CustomerForm /> },
                  { path: '/customers/:id/edit', element: <CustomerForm /> },
                  { path: '/customers/:id', element: <CustomerDetail /> },
                  { path: ROUTES.SETTINGS, element: <Settings /> },
                  { path: ROUTES.USERS, element: <Users /> },
                  { path: ROUTES.USER_CREATE, element: <UserForm /> },
                  { path: '/users/:id/edit', element: <UserForm /> },
                  { index: true, element: <Navigate to={ROUTES.DASHBOARD} replace /> },
                ],
              },
            ],
          },
        ],
      },
      { path: '/', element: <RootRedirect /> },
      { path: '*', element: <RootRedirect /> },
    ],
  },
]);
